var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogStatus
    ? _c(
        "v-app",
        {
          class: _vm.dialogStatus ? "addHeight" : "",
          attrs: { id: "confirmation-dialog" }
        },
        [
          _c(
            "v-dialog",
            {
              staticClass: "dialog__container",
              attrs: {
                "max-width": _vm.width,
                value: _vm.dialogStatus,
                persistent: ""
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "confirmation-dialog-card" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pt-4" },
                    [
                      _c("p", {
                        staticClass: "confirmation-title",
                        domProps: { textContent: _vm._s(_vm.title) }
                      }),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "closeIcon",
                          attrs: { icon: "", title: "close" },
                          on: {
                            click: function($event) {
                              return _vm.sendInfoToParent("close")
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c(
                      "div",
                      { staticClass: "popup-content" },
                      [_vm._t("default")],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "pb-6" },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm._l(_vm.actions, function(action, index) {
                        return _c("v-btn", {
                          key: index,
                          class: [
                            index == 0
                              ? _vm.enableFreemiumTheme
                                ? "verified-dis-btn"
                                : "disable__cd"
                              : _vm.enableFreemiumTheme
                              ? "verified-ena-btn"
                              : "enable__cd",
                            action.status === "disable"
                              ? "complete-disable"
                              : "complete-enable"
                          ],
                          attrs: { depressed: "" },
                          domProps: { textContent: _vm._s(action.text) },
                          on: {
                            click: function($event) {
                              return _vm.sendInfoToParent(action)
                            }
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }